import { Choose } from '~/models/choose';
import { Image } from '~/models/image';

export const chooseService = {
	fetch: async (): Promise<Choose.Model | null> => {
		const params = {
			fields: ['*', 'images.*', 'images.directus_files_id.*', 'form.*'],
		};

		try {
			const response = await $fetch<
				Omit<Choose.Model, 'images'> & { images: { directus_files_id: Image.Model }[] }
			>(Choose.api, {
				method: 'POST',
				body: { params },
			});

			/** Resolve images */
			const images = response.images.reduce((acc, { directus_files_id }) => {
				acc.push(directus_files_id);
				return acc;
			}, [] as Image.Model[]);

			return { ...response, images };
		} catch (error) {
			console.error('Failed to fetch Choose:', error);

			return null;
		}
	},
};
